export { Wishlists } from './Wishlists'
export type { WishlistsProps } from './Wishlists'
